export interface ILab {
  id?: string;
  labid: string;
  sampleid: string;
  test_date: string;
  testing_method: TestingMethod;
  tissue: Tissue;
  pathogen: Pathogen;
  result: boolean;
  createdby?: string;
  groupid?: string;
  groupname?: string;
  userlogin?: string;
}

export enum PATHOGENS {
  '' = 'No pathogen',
  'pathogen_a' = 'Pathogen A',
  'pathogen_b' = 'Pathogen B',
  'pathogen_c' = 'Pathogen C',
}
export type Pathogen = keyof typeof PATHOGENS;

export enum TISSUES {
  '' = 'No tissue',
  'tissue_a' = 'Tissue A',
  'tissue_b' = 'Tissue B',
  'tissue_c' = 'Tissue C',
}
export type Tissue = keyof typeof TISSUES;

export enum TESTING_METHODS {
  '' = 'No testing method',
  'testing_method_a' = 'Testing Method A',
  'testing_method_b' = 'Testing Method B',
  'testing_method_c' = 'Testing Method C',
}
export type TestingMethod = keyof typeof TESTING_METHODS;
